import EvaPlugin from "@eva/client/plugins/EvaPlugin";

class StoragesEvaPlugin extends EvaPlugin {
  constructor(app) {
    super(app);
  }
}

export default StoragesEvaPlugin;
